import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import httfront from '../images/bluebanner.jpg';
import httlogo from '../images/httcrop.png';
import { Row, Col, Container, Image } from 'react-bootstrap';

function Contact() {
    return (
        <div>
            <Image
                src={httlogo}
                alt="background"
                style={{
                    top: 0,
                    left: window.innerWidth < 768 ? '110px' : '30px',
                    height: '75px',
                }}
            />
            <TopMenu />
            <h2 className='htitleb text-center'>Contact</h2>
            <Container>
                <Row className='justify-content-start'>
                    <Col md={6}>
                        <Image
                            src={httfront}
                            width={'100%'}
                        />
                    </Col>
                    <Col md={6}>
                        <b>Address</b><br />311 Pacific Street<br />Honolulu, Hawaii 96817<br /><hr />
                        <b>Marc C. Tilker</b><br /><i>Dealer Principal</i><br /> 808-532-7425
                        <br /><br />
                        <Row>
                            <Col>
                                <b>Ray Oberacker</b><br /><i>Sales Manager</i><br />808-532-7507
                            </Col>
                            <Col>
                                <b>Truck Sales Department</b><br />808-532-7512
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <b>Jason Farquhar</b><br /><i>Parts Manager</i><br />808-532-7536
                            </Col>
                            <Col>
                                <b>Parts Department</b><br />808-532-7501
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <b>Joel Lamonthe</b><br /><i>Service Manager</i><br />808-532-7517
                            </Col>
                            <Col>
                                <b>Service Department</b><br />808-532-7517
                            </Col>
                        </Row>
                        <br />
                    </Col>
                </Row>
            </Container>
            <BottomMenu />
        </div>
    );
}

export default Contact;